<template>
  <board-restore-widget :org-ref="orgRef" :key="`${orgRef}-board-restore`" :dismiss="dismiss" />
</template>

<script>
import { BoardRestoreWidget } from '../widgets'
import { Modal } from '@argon/app/mixins'
export default {
  mixins: [Modal],
  components: { BoardRestoreWidget },
  props: {
    orgRef: String
  }
}
</script>
